import React, {Component} from 'react';
import Select from 'react-virtualized-select';

import 'react-virtualized-select/styles.css';

import styles from './styles.less';

export default class VirtualizedSelect extends Component {
	constructor(props, context, updater) {
		super(props, context, updater);
		this.optionsNodes = {};
		this.optionsHeight = {};
	}

	render() {
		let {className, optionHeight, wide, optionRenderer, closeOnSelect, ...props} = this.props;
		className = className ? className : '';
		className += ' bsui-virtualized-select';

		if (wide) {
			className += ' bsui-virtualized-select_wide';
		}

		if (closeOnSelect === undefined) {
			props.closeOnSelect = false;
		}

		optionHeight = (data) => {
			let optionIndex = this.props.options.indexOf(data.option);

			if (this.optionsHeight.hasOwnProperty(optionIndex)) {
				return this.optionsHeight[optionIndex];
			}

			return 24;
		};

		const _optionRenderer = (ref) => {
			let option;

			if (!this.optionsHeight.hasOwnProperty(ref.option.value)) {
				try {
					ref.style.height = 'auto';
				}
				catch (e) {
				}
			}

			if (optionRenderer) {
				option = optionRenderer(ref);
			} else {
				option = this.select._optionRenderer(ref);
			}

			return <div key={option.key} ref={div => this.optionsNodes[ref.optionIndex] = div}>{option}</div>;
		};

		return <Select className={className} optionHeight={optionHeight} optionRenderer={_optionRenderer} {...props}
			ref={select => this.select = select}
			listProps={{
				ref: (list) => this.list = list,
				onRowsRendered: (data) => {
					if (this.onRowsRenderedTimeout) {
						clearTimeout(this.onRowsRenderedTimeout);
					}

					this.onRowsRenderedTimeout = setTimeout(() => {
						let hasUpdate = false;

						for (let i = data.overscanStartIndex; i <= data.overscanStopIndex; i++) {
							if (!this.optionsHeight.hasOwnProperty(i)) {
								this.optionsHeight[i] = this.optionsNodes[i].firstChild.clientHeight;
								this.list.recomputeRowHeights(i);
								hasUpdate = true;
							}
						}

						if (hasUpdate) {
							this.select.forceUpdate();
						}
					});
				}
			}} />;
	}
}
